<template>
<!-- 机构设置  -->
    <div class="organ">
        机构设置
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        }
    }
</script>

<style lang="less" scoped>

</style>